import { type BucketSelection, DocumentViewMode, type OverlayState } from "../types";

export interface GraphLocation {
    mode: DocumentViewMode;
    category: string;
    selected?: BucketSelection;
    focusedAssetId?: string;
    overlay?: OverlayState;
    gridPage: number;
}

export interface GraphSearch {
    view?: string;
    field?: string;
    value?: string;
    asset?: string;
    overlay?: string;
    page?: string;
    gridPage?: string;
}

const OVERVIEW = "overview";

const toPage = (raw: string | undefined): number => {
    const parsed = Number.parseInt(raw ?? "", 10);
    return Number.isNaN(parsed) || parsed < 0 ? 0 : parsed;
};

export const readGraphLocation = (search: GraphSearch): GraphLocation => {
    const category = search.field ?? "";
    const selected =
        category && search.value ? { field: category, value: search.value } : undefined;
    const overlay = search.overlay
        ? { field: search.overlay, label: search.overlay, page: toPage(search.page) }
        : undefined;

    return {
        mode: search.view === OVERVIEW ? DocumentViewMode.EXPLODE : DocumentViewMode.TABLE,
        category,
        ...(selected ? { selected } : {}),
        ...(search.asset ? { focusedAssetId: search.asset } : {}),
        ...(overlay ? { overlay } : {}),
        gridPage: toPage(search.gridPage),
    };
};

export const writeGraphLocation = (location: GraphLocation): GraphSearch => ({
    view: location.mode === DocumentViewMode.EXPLODE ? OVERVIEW : undefined,
    field: location.category || undefined,
    value: location.selected?.value,
    asset: location.focusedAssetId,
    overlay: location.overlay?.field,
    page: location.overlay ? String(location.overlay.page) : undefined,
    gridPage: location.gridPage > 0 ? String(location.gridPage) : undefined,
});
